import React from 'react';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import '../styles/accordion.css';

export function Context({ contextArray }) {
  return (
    <section>
      <h3>Contextual variables</h3>
      <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
        {contextArray.map((contextCompetency, id) => {
          return (
            <AccordionItem key={id}>
              <AccordionItemHeading>
                <AccordionItemButton>
                  <span>{contextCompetency.context}</span>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p className="bold">The career professional has knowledge and understanding of</p>
                <ul>
                  {contextCompetency.tunnistaa_ja_ymmartaa.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
                <p className="bold">The career professional is able to</p>
                <ul>
                  {contextCompetency.osaa.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </AccordionItemPanel>
            </AccordionItem>
          );
        })}
      </Accordion>
    </section>
  );
}
